import { Injectable } from '@angular/core';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { IInventoryLocation } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class InventoryLocationService extends BaseService<IInventoryLocation> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'inventoryLocation');
  }
}

export { IInventoryLocation } from '../shared/api';
